import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { LotDetailsDto } from '.';

export class LotDetailsResModel extends GlobalResponseObject {
    data?: LotDetailsDto[];
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data //LotDetailsDto[]
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: LotDetailsDto[]) {
        super(status, intlCode, internalMessage);
        this.data = data;
    }
}
